(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.ky-collection-card__atc');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled = true;

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds.join(',')
      })
    })
      .then(res => res.json())
      .then(async (response) => {
        const drawer = document.querySelector('cart-drawer-component');

        if (response.status) {
          // Stock/limit reached — nothing was added. Open the drawer and show
          // the same per-line error message the cart page already uses,
          // under the affected product's row.
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const lineIndex = cart.items.findIndex((item) => item.variant_id === variantId);
          const cartQty = lineIndex > -1 ? cart.items[lineIndex].quantity : 0;
          const lineNumber = lineIndex + 1;

          drawer?.open();

          if (lineNumber > 0) {
            const errorContainer = document.querySelector(`[ref="cartItemErrorContainer-${lineNumber}"]`);
            const errorText = document.querySelector(`[ref="cartItemError-${lineNumber}"]`);
            if (errorContainer && errorText) {
              errorText.textContent = `Stok durumu nedeniyle sepetinize yalnızca ${cartQty} ürün eklendi.`;
              errorContainer.classList.remove('hidden');
            }
          }
          return;
        }

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: response,
              sourceId: 'ky-collection-card',
              data: { source: 'ky-collection-card', sections: response.sections }
            }
          })
        );
        drawer?.open();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        btn.disabled = false;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.ky-collection-card__atc');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled = true;

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds.join(',')
      })
    })
      .then(res => res.json())
      .then(async (response) => {
        const drawer = document.querySelector('cart-drawer-component');

        if (response.status) {
          // Stock/limit reached — nothing was added. Open the drawer and show
          // the same per-line error message the cart page already uses,
          // under the affected product's row.
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const lineIndex = cart.items.findIndex((item) => item.variant_id === variantId);
          const cartQty = lineIndex > -1 ? cart.items[lineIndex].quantity : 0;
          const lineNumber = lineIndex + 1;

          drawer?.open();

          if (lineNumber > 0) {
            const errorContainer = document.querySelector(`[ref="cartItemErrorContainer-${lineNumber}"]`);
            const errorText = document.querySelector(`[ref="cartItemError-${lineNumber}"]`);
            if (errorContainer && errorText) {
              errorText.textContent = `Stok durumu nedeniyle sepetinize yalnızca ${cartQty} ürün eklendi.`;
              errorContainer.classList.remove('hidden');
            }
          }
          return;
        }

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: response,
              sourceId: 'ky-collection-card',
              data: { source: 'ky-collection-card', sections: response.sections }
            }
          })
        );
        drawer?.open();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        btn.disabled = false;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-carousel"] && !Shopify.designMode) return;
  try {
    
  const track = document.querySelector(`#shopify-section-{{ section.id }} .product-video-carousel__track`);
  const prevBtn = document.querySelector(`#shopify-section-{{ section.id }} [data-carousel-prev]`);
  const nextBtn = document.querySelector(`#shopify-section-{{ section.id }} [data-carousel-next]`);

  if (track && prevBtn && nextBtn) {
    const scrollAmount = () => {
      const item = track.querySelector('.product-video-carousel__item');
      return item ? item.offsetWidth + 12 : 200;
    };

    const updateButtons = () => {
      prevBtn.toggleAttribute('data-hidden', track.scrollLeft <= 0);
      nextBtn.toggleAttribute('data-hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 1);
    };

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount() * 2, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount() * 2, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  }

  } catch(e) { console.error(e); }
})();
})();
